import { IApplicationState } from '../../types/redux';
import { EUserStatus } from '../../types/newReview/userStatus';

export const getUserStatus = (state: IApplicationState): EUserStatus => {
  return state.newReview.data.userStatus;
};
